import React, { useEffect } from 'react'
import { useState,useRef } from 'react';
import useStateWithCallback from "use-state-with-callback";
import { useNavigate, useParams } from 'react-router';
import { CommonUtil } from '../../../utils/CommonUtil';
import { NetworkManager } from '../../../Components/NetworkManager';
import { IAGrid } from '../../../Components/IInterfaces';
import { Constants } from '../../Languages/Constants';
import InspectionGrid from '../../InspectionGrid/InspectionGrid';
import InterchangeRenderer from '../../InterchangeApplication/InterchangeRenderer';
import EditClaimModalRenderer from '../../InterchangeApplication/EditClaimModalRenderer';
import InterchangeDocumentStatusRenderer from '../../InterchangeApplication/InterchangeDocumentStatusRenderer';
import ResponseClaimRenderer from '../../InterchangeApplication/InspectionCompareDetails/ResponseClaimRenderer';
import GenericPopup from '../../../Components/GenericPopup';
import ClaimsForm from './ClaimsForm';
import ToastManager from '../../../Components/ToastManager';
import SettleClaim from './SettleClaim';

interface IClaim {
  getDashboardCount: () => void
}

const ClaimsGrid = ({getDashboardCount}: IClaim) => {
  const saasOrgId = CommonUtil.getSaasOrgId();
  const userId = CommonUtil.getUserId();
  const navigate = useNavigate();
  const [popupInfo, setPopupInfo] = useState<any>(null);
  const userGridRef1 = useRef<IAGrid>(null);
  const [users,setUsers] = useStateWithCallback([],()=>{
    if(userGridRef1.current){
        userGridRef1.current.columnFittoSize();
    }
  });
  
  useEffect(() => {
    if(popupInfo === null){
    getAllClaims();
  }
  }, [popupInfo]);

  const [userColumns] = useState([
      { field: 'inspectionDocumentCode', headerName: CommonUtil.getMessageText(Constants.DOCUMENT_ID, 'Document'), resizable: true, flex: 1, width: 100, sortable: true, cellStyle: { 'fontWeight': '400', 'letterSpacing': '0px', 'fontSize': '12px', 'fontFamily': 'poppins', 'color': 'black' }, headerClass: 'header-white',filter: 'agTextColumnFilter', cellRenderer: InterchangeRenderer },
      { field: 'equipType', headerName: "Equipment Type", resizable: true, flex: 1, width: 100, sortable: true, cellStyle: { 'fontWeight': '400', 'letterSpacing': '0px', 'fontSize': '13px', 'fontFamily': 'poppins', 'paddingTop': '5px' }, headerClass: 'header-white',filter: 'agTextColumnFilter' },
      { field: 'unitNumber', headerName: CommonUtil.getMessageText(Constants.UNIT_NUMBER, 'Unit Number'), resizable: true, flex: 1, width: 100, sortable: true, cellStyle: { 'fontWeight': '400', 'letterSpacing': '0px', 'fontSize': '13px', 'fontFamily': 'poppins', 'paddingTop': '5px' }, headerClass: 'header-white',filter: 'agTextColumnFilter' },
      { field: 'vinNumber', headerName:CommonUtil.getMessageText(Constants.VIN_NO,'Vin Number'),resizable:true,flex:1,width:100,sortable:true,cellStyle: { 'fontWeight': '400','letterSpacing':'0px','fontSize':'13px','fontFamily':'poppins','paddingTop':'5px' },headerClass: 'header-white',filter: 'agTextColumnFilter' },
      { field: 'claimDateString', headerName: 'Creation Date', resizable: true, flex: 1, width: 100, sortable: true, cellStyle: { 'fontWeight': '400', 'letterSpacing': '0px', 'fontSize': '13px', 'fontFamily': 'poppins' }, headerClass: 'header-white',filter: 'agDateColumnFilter' },
      { field: 'claimCreatorName', headerName:CommonUtil.getMessageText(Constants.CREATED_BY,'Created By'),resizable:true,flex:1,width:100,sortable:true,cellStyle: { 'fontWeight': '400','letterSpacing':'0px','fontSize':'13px','fontFamily':'poppins' },headerClass: 'header-white',filter: 'agTextColumnFilter'},
      { field: 'claimCode', headerName: CommonUtil.getMessageText(Constants.CLAIM, 'Claim Id'), resizable: true, flex: 1, width: 100, sortable: true, cellStyle: { 'fontWeight': '400', 'letterSpacing': '0px', 'fontSize': '12px', 'fontFamily': 'poppins', 'color': 'black' }, headerClass: 'header-white',filter: 'agTextColumnFilter', cellRenderer:(params: any) => (
            <span
                onClick={() => openEditPopup(params.data)}
                style={{ color: '#0d6efd', cursor: 'pointer', textDecoration: 'underline' }}
            >
            {params.value}
            </span>
        )},
      { field: 'claimAmount', headerName: CommonUtil.getMessageText(Constants.CLAIMED_AMOUNT, 'Claimed Amount'), flex: 1, width: 100, sortable: true, cellStyle: { 'fontWeight': '400', 'letterSpacing': '0px', 'fontSize': '13px', 'fontFamily': 'poppins' }, headerClass: 'header-white',filter: 'agTextColumnFilter' },
      { field: 'approvedByOrgName', headerName:CommonUtil.getMessageText(Constants.SETTLED_BY,'Settled By'),resizable:true,flex:1,width:100,sortable:true,cellStyle: { 'fontWeight': '400','letterSpacing':'0px','fontSize':'13px','fontFamily':'poppins' },headerClass: 'header-white',filter: 'agTextColumnFilter'},
      { field: 'approvedDate', headerName: CommonUtil.getMessageText(Constants.SETTLED_ON, 'Settled On'), flex: 1, width: 100, sortable: true, cellStyle: { 'fontWeight': '400', 'letterSpacing': '0px', 'fontSize': '13px', 'fontFamily': 'poppins' }, headerClass: 'header-white',filter: 'agDateColumnFilter' },
      { field: 'claimStatus', headerName: CommonUtil.getMessageText(Constants.STATUS, 'Status'), resizable: true, flex: 1, width: 100, sortable: true, cellStyle: { 'fontWeight': '400', 'letterSpacing': '0px', 'fontSize': '13px', 'fontFamily': 'poppins' }, headerClass: 'header-white',filter: 'agTextColumnFilter', cellRenderer: InterchangeDocumentStatusRenderer },
      {headerName:CommonUtil.getMessageText(Constants.REFERENCE_NUMBER,'Actions'),resizable:true,flex:1,width:100,sortable:true,cellStyle: { 'fontWeight': '400','letterSpacing':'0px','fontSize':'13px','fontFamily':'poppins','paddingTop':'5px' },headerClass: 'header-white',filter: 'agTextColumnFilter',cellRenderer:(params: any) => (
            <button disabled={Number(userId) !== 1} className="btn btn-danger mb-3" onClick={()=>onSettleClaim(params.data)}>{"Settle"}</button>
        )},
  ]);
  
  const onLoginError = (err:any)=>{
      console.log(err);
  }
  
  useEffect(()=>{
    getAllClaims();
  }, []);
  
  const getAllClaims = () =>{
    var orgUrl = `api/claim/orgId/${saasOrgId}`
    NetworkManager.sendJsonRequest(orgUrl,"","","GET",true,onGetAllClaims,onLoginError);
  }
  
  const onClickUserDetails = (userData:any) =>{
    localStorage.setItem("documentId", userData.inspectionDocumentId);    
    localStorage.setItem("documentCode", userData.inspectionDocumentCode);  
    navigate("/menu/inspectionDashboard/inspectionDocument");
    console.log(userData);
    }

  const onReceiveData = (userData: any) => {
    localStorage.setItem("claimId",userData.claimId)
   console.log(userData);
   
  }

  const onSettleClaim = (rowData: any) => {
    setPopupInfo({
      mode: "open",
      formKey: "settleClaim",
      initialData: rowData,
    });
  };
  
  const openEditPopup = (rowData: any) => {
    setPopupInfo({
      mode: "edit",
      formKey: "claim",
      initialData: rowData,
    });
  };

  const closePopup = () => {
    setPopupInfo(null)
    getDashboardCount();
  };

  const onGetAllClaims = (dataObj:any)=>{
    if(dataObj) {
      var restData = JSON.parse(dataObj);
      if(restData && !restData.errorMessage){
          restData.map((org:any)=>{
              console.log(org.documentId)
          })
          setUsers(restData)
      }else{
        ToastManager.showToast(restData.errorMessage, "Error");
      }
      if(restData && !restData.errorMessage){
          var users = [];
          if(Array.isArray(restData)){
              users = restData;
          }else{
              users.push(restData);
              
          }
          let ascendingUsers:any = [...restData].sort((a,b)=>{
              return b.documentId - a.documentId
            }) 
            setUsers(ascendingUsers)    
          console.log(users)   
      }else{
        ToastManager.showToast(restData.errorMessage, "Error");
      }
    }
  }

  return (
    <div className="container-fluid container-fluid-padding mt-3" style={{backgroundColor:'white'}}>
      <div className="row fs-7 pt-1">
      <div className="ag-theme-alpine ag-theme-customeTheme gridHeight" style={{ height: "calc(100vh - 330px)", width: "100%",paddingLeft:"8px",paddingRight:"5px" }}>
      <InspectionGrid cols={userColumns} rows={users} pageSize={100} addNew={true} tooltip={"Add Company"} name={"Add Company"}
        headerHeight={CommonUtil.GRID_HEADER_HEIGHT} rowHeight={CommonUtil.GRID_ROW_HEIGHT} ref={userGridRef1} method={{ onClickUserDetails,onReceiveData }} 
        />
      </div>
      </div>
      {popupInfo?.formKey === "claim" && (
        <GenericPopup
          header="Claim"
          mode={popupInfo?.mode}
          onClose={closePopup}
          size="lg"
        >
          <ClaimsForm mode={popupInfo.mode} onClose={closePopup} initialData={popupInfo.initialData} />
        </GenericPopup>
      )}
      {popupInfo?.formKey === "settleClaim" && (
        <GenericPopup
          header="Respond to Claim"
          mode={popupInfo?.mode}
          onClose={closePopup}
          size="sm"
        >
          <SettleClaim mode={popupInfo.mode} onClose={closePopup} data={popupInfo.initialData} />
        </GenericPopup>
      )}
    </div>
  )
}

export default ClaimsGrid